let geoData = null;

async function fetchGeoData() {
  try {
    const res = await fetch('https://api.ipinfo.io/lite/me?token=8e53f243b26a54');
    geoData = await res.json();
    return geoData;
  } catch (e) {
    console.error('Geo fetch failed:', e);
    geoData = { country_code: 'US' }; // fallback
    return geoData;
  }
}

function setupIntlTelInput(countryCode) {
  const input = document.querySelector("#customer-phone");
  if (!input) return;

  const iti = window.intlTelInput(input, {
    initialCountry: countryCode,
    separateDialCode: true,
    utilsScript: "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.19/js/utils.js"
  });

  const form = document.querySelector(".popup__newsletter");
  if (form) {
    form.addEventListener("submit", function () {
      input.value = iti.getNumber();
    });
  }
}

function closeGeoPopup() {
  document.getElementById('geo-popup-backdrop').style.display = 'none';
  sessionStorage.setItem('geoPopupDismissed', 'true');
}

function showGeoPopupIfNeeded(countryCode) {
  const isIndiaSite = window.location.hostname.includes("meherbaa.in");

  const shouldShowPopup =
    (countryCode === 'IN' && !isIndiaSite) ||
    (countryCode !== 'IN' && isIndiaSite);

  if (!shouldShowPopup) return;

  const popup = document.getElementById('geo-popup');
  const header = popup.querySelector('h2');
  const text = popup.querySelector('p');
  const btn = popup.querySelector('button');

  if (countryCode === 'IN') {
    header.textContent = "You're visiting from India";
    text.textContent = "You are visiting Meherbaa's International Store. Would you like to browse the Meherbaa India store instead?";
    btn.textContent = "Take me to Meherbaa.in";
    btn.onclick = () => window.location.href = "https://www.meherbaa.in";
  } else {
    header.textContent = "You're visiting from outside India";
    text.textContent = "You are visiting Meherbaa India. Would you like to shop from our International store instead?";
    btn.textContent = "Take me to Meherbaa.com";
    btn.onclick = () => window.location.href = "https://www.meherbaa.com";
  }

  document.getElementById('geo-popup-backdrop').style.display = 'block';
}

document.addEventListener("DOMContentLoaded", async function () {
  const geo = await fetchGeoData();

  // Always set up phone input with country
  setupIntlTelInput(geo.country_code);

  // Show popup only if not dismissed this session
  if (!sessionStorage.getItem('geoPopupDismissed')) {
    showGeoPopupIfNeeded(geo.country_code);
  }
});